exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-a4caebe2] .md-table-head-label {\r\n    color: #4caf50 !important;\n}\n[data-v-a4caebe2] .md-table-head {\r\n    cursor: default;\n}\n.table-hover[data-v-a4caebe2] {\r\n    cursor: pointer;\n}\r\n", ""]);

// exports
